import { render, staticRenderFns } from "./Effect1.vue?vue&type=template&id=3b5eda18&"
import script from "./Effect1.vue?vue&type=script&lang=js&"
export * from "./Effect1.vue?vue&type=script&lang=js&"
import style0 from "./Effect1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports